<template>
  <a-spin :spinning="loading">
    <a-row>
      <a-card hoverable>
        <a-card-meta :title="fillOut.person_name || 'ANÓNIMO'"
                     :description="fillOut.id_person">
          <a-avatar
            slot="avatar"
            :src="profileSrc"
          />
        </a-card-meta>
        <template v-if="biodata && $getConfigValue('MOSTRAR_BOTON_FINALIZAR_FORMULARIOS', 'NO') === 'NO'" class="ant-card-actions" slot="actions">
          <a-progress style="width: 80%" :strokeColor="{
        '0%': '#108ee9',
        '100%': '#87d068',
      }" :percent="parseFloat(fillOut.porcentaje)" status="active"/>
        </template>
      </a-card>
    </a-row>
    <a-row v-if="$getConfigValue('MENSAJE_FORMULARIO')">
      &nbsp;
      <a-alert type="info" showIcon>
            <span slot="message" v-html="$getConfigValue('MENSAJE_FORMULARIO')">
            </span>
      </a-alert>
    </a-row>
    <a-row>
      <a-form-model ref="mainForm" :model="respuestas" v-bind="fiOptions">
        <a-collapse v-if="fillOut.form" v-model="activeHeaders">
          <a-collapse-panel v-for="header in fillOut.form.active_headers" :key="header.id.toString()"
                            :header="header.name">
            <a-row :gutter="[16,16]">
              <a-col v-bind="colOptions" v-for="component in header.active_components">

                <a-form-model-item :label="component.label" :prop="component.name"
                                   :hasFeedback="component.h_component_type !== 'CHECKBOX' && component.h_component_type !== 'RADIO'"
                                   :rules="[{required: component.required, message: `El campo ${component.label} es requerido.`}]">

                  <template v-if="component.h_component_type === 'LOV_SQL'">
                    <form-model-dropdown style="width: 100%"
                                         v-model="respuestas[component.name]"
                                         endpoint="forms_components/sql_lov_param_values"
                                         :cache="false"
                                         :params="{...respuestas, id_param: component.id}"
                                         @change="propChanged($event, component)"
                                         :disabled="loadingBtn['comp_'+component.id]"
                                         :loading="loadingBtn['comp_'+component.id]">
                    </form-model-dropdown>
                  </template>

                  <a-select v-else-if="component.h_component_type === 'LOV'"
                            v-model="respuestas[component.name]"
                            style="width: 100%"
                            @change="propChanged($event, component)"
                            :disabled="loadingBtn['comp_'+component.id]"
                            :loading="loadingBtn['comp_'+component.id]">
                    <a-select-option :value="option.value" v-for="option in component.options">
                      {{option.label}}
                    </a-select-option>
                  </a-select>
                  <a-input-number v-else-if="component.h_component_type === 'NUMBER'"
                                  v-model="respuestas[component.name]"
                                  style="width: 100%"
                                  @blur="propChanged(respuestas[component.name], component)"
                                  :disabled="loadingBtn['comp_'+component.id]"
                                  :loading="loadingBtn['comp_'+component.id]"></a-input-number>

                  <a-date-picker v-else-if="component.h_component_type === 'DATE'"
                                 v-model="respuestas[component.name]"
                                 style="width: 100%"
                                 @change="propChanged($event, component)"
                                 :disabled="loadingBtn['comp_'+component.id]"
                                 :loading="loadingBtn['comp_'+component.id]"></a-date-picker>
                  <a-checkbox-group v-model="respuestas[component.name]"
                                    v-else-if="component.h_component_type === 'CHECKBOX'"
                                    @change="propChanged($event, component)">

                    <div v-for="option in component.options">
                      <a-checkbox :value="option.value">
                        {{option.label}}
                      </a-checkbox>
                    </div>
                  </a-checkbox-group>
                  <a-radio-group v-model="respuestas[component.name]"
                                 v-else-if="component.h_component_type === 'RADIO'"
                                 @change="(e) => propChanged(e.target.value, component)">
                    <div v-for="option in component.options">
                      <a-radio :value="option.value">
                        {{option.label}}
                      </a-radio>
                    </div>
                  </a-radio-group>
                  <a-textarea v-else-if="component.h_component_type === 'TEXTAREA'"
                              auto-size
                              v-model="respuestas[component.name]"
                              @blur="(e) => propChanged(respuestas[component.name], component)"
                              :disabled="loadingBtn['comp_'+component.id]"
                              :loading="loadingBtn['comp_'+component.id]"></a-textarea>
                  <a-input v-else
                           v-model="respuestas[component.name]"
                           @blur="(e) => propChanged(respuestas[component.name], component)"
                           :disabled="loadingBtn['comp_'+component.id]"
                           :loading="loadingBtn['comp_'+component.id]"></a-input>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-collapse-panel>
        </a-collapse>
      </a-form-model>
    </a-row>
    <br>
    <div v-if="biodata && $getConfigValue('MOSTRAR_BOTON_FINALIZAR_FORMULARIOS') === 'SI'" style="text-align: right">
      <a-button
        type="primary"
        html-type="submit"
        @click="redirect">
        Finalizar
      </a-button>
    </div>
  </a-spin>
</template>
<script>
  import JsUtils from '@/util/JsUtils'
  import HttpUtil from '@/util/HttpUtil'
  import DateUtils from '@/util/DateUtils'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    data () {
      return {
        fiOptions: {
          'label-col': {span: 24},
          'wrapper-col': {span: 24}
        },
        loading: false,
        fillOutId: '',
        biodata: false,
        fillOut: {},
        activeHeaders: [],
        respuestas: {},
        loadingBtn: {},
        componentTypes: {},
        defaultPicture: require('./../../assets/anon_profile.png'),
        profileSrc: require('./../../assets/anon_profile.png')
      }
    },
    mounted () {
      this.fillOutId = this.$route.query.fillOutId
      this.biodata = this.$route.query.formulario_desde_biodata
      if (JsUtils.isEmpty(this.fillOutId)) {
        this.$router.push('404')
      } else {
        this.httpClient = new HttpUtil('forms_fillout')
        this.loadForm()
      }
    },
    methods: {
      loadForm () {
        this.loading = true
        this.httpClient.show(this.fillOutId, (response) => {
          this.processForm(response)
          this.loadEmployPicture(response.data.id_person)
        }, () => {
          this.$router.push('404')
        }).then(() => {
          this.loading = false
        })
      },
      propChanged (e, component) {
        if (!JsUtils.isEmpty(e)) {
          let request = {
            id_component: component.id,
            id_fillout: this.fillOutId
          }
          switch (component.h_component_type) {
            case 'DATE':
              request.value = DateUtils.forBackEnd(e)
              break
            case 'CHECKBOX':
              let result = ''
              e.map(v => {
                result += (v + ',')
              })
              request.value = (result + 'XX').replace(',XX', '')
              break
            case 'LOV':
            case 'LOV_SQL':
            case 'NUMBER':
            case 'TEXT':
            case 'TEXTAREA':
            case 'RADIO':
              request.value = e
              break
          }

          this.loadingBtn['comp_' + component.id] = true
          this.$forceUpdate()

          this.httpClient.getInstance().post('forms_fillout_resp', request)
            .then(response => {
              this.fillOut.porcentaje = response.data.porcentaje
              Mensajes.success('Correcto', 'Guardado correctamente')
            })
            .catch(error => {
              let msj = 'Error desconocido, contacte al administrador'
              if (error.response.data.message) {
                msj = error.response.data.message
              }
              Mensajes.error('Error', msj)
            })
            .then(() => {
              this.loadingBtn['comp_' + component.id] = false
              this.$forceUpdate()
            })
        }
      },
      getType (tipoOiginal) {
        switch (tipoOiginal) {
          case 'NUMBER':
            return 'number'
          case 'CHECKBOX':
            return 'array'
          /*
          case 'DATE':
          case 'LOV':
          case 'TEXT':
          case 'TEXTAREA':
          case 'RADIO':
            return 'any'
          */
        }
        return 'any'
      },
      processForm (response) {
        this.fillOut = response.data
        this.activeHeaders.splice(0, this.activeHeaders.length)
        this.loadingBtn = {}
        this.componentTypes = {}
        this.fillOut.form.active_headers && this.fillOut.form.active_headers.map(header => {
          header.active_components && header.active_components.map(comp => {
            comp['name'] = 'comp_' + comp.id
            this.componentTypes['comp_' + comp.id] = comp.h_component_type
            this.respuestas['comp_' + comp.id] = null
          })
          this.activeHeaders.push(header.id.toString())
        })

        this.processResponses()
      },
      processResponses () {
        this.$refs.mainForm.resetFields()
        let resps = {}
        this.fillOut.responses.map(r => {
          if (this.componentTypes['comp_' + r.id_component] === 'CHECKBOX') {
            resps['comp_' + r.id_component] = r.value.split(',')
          } else if (this.componentTypes['comp_' + r.id_component] === 'DATE') {
            resps['comp_' + r.id_component] = moment(r.value)
          } else if (this.componentTypes['comp_' + r.id_component] === 'NUMBER') {
            resps['comp_' + r.id_component] = parseFloat(r.value)
          } else {
            resps['comp_' + r.id_component] = r.value
          }
        })

        this.respuestas = resps
      },
      loadEmployPicture (idPerson) {
        this.profileSrc = this.defaultPicture
        this.httpClient.getInstance().get('picture_service/render/profile/' + idPerson, {
          responseType: 'arraybuffer'
        })
          .then((response) => {
            let blob = new Blob([response.data], {type: response.headers['content-type']})
            this.profileSrc = window.URL.createObjectURL(blob)
          })
          .catch(() => {})
      },
      redirect () {
        this.$router.push({name: 'Self Service Dashboard'})
      }
    },
    computed: {
      colOptions () {
        return {xs: 24, sm: 24 / this.fillOut.form.num_cols}
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Formularios/FormFillout.vue